import React from 'react';
import clsx from 'clsx';
import styles from './Checkbox.module.scss';

export type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange' | 'className'> & {
  label: React.ReactNode | string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
  isDarkLabel?: boolean;
  subtext?: React.ReactNode | string;
};

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled,
  className,
  labelClassName,
  isDarkLabel,
  subtext,
  ...rest
}) => (
  <div className={clsx(styles.wrapper, className)}>
    <label
      htmlFor={id}
      className={styles.labelWrapper}
    >
      <input
        id={id}
        name={name}
        type='checkbox'
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
      {label && <span className={clsx(styles.label, labelClassName, { [styles.dark]: isDarkLabel })}>{label}</span>}
    </label>
    {subtext && (
      <div className={styles.subtext}>{subtext}</div>
    )}
  </div>
);

export default Checkbox;
